e360.service('advSearchApi', [
   '$http', 'apiHelper', 'fileDownload',
   function ($http, apiHelper, fileDownload) {
      return {
         search: function (args, offset, limit) {
            offset = typeof offset !== 'undefined' ? offset : 0;
            limit = typeof limit !== 'undefined' ? limit : 16;
            var url = apiHelper.getApiUrl('search', {offset: offset, limit: limit});
            return $http.post(url, args);
         },

         download: function (args) {
            new fileDownload(apiHelper.getApiUrl('export/search'), args).post();
         },

         invitees: function (args, eventId, campaignId) {
            var urlArgs = {};

            if (angular.isDefined(eventId) && eventId !== null) {
               urlArgs.eventId = eventId;
            }

            if (angular.isDefined(campaignId) && campaignId !== null) {
               urlArgs.campaignId = campaignId;
            }

            var url = apiHelper.getApiUrl('search/createInvitees', urlArgs);
            return $http.post(url, args);
         }
      };
   }
]);
